'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface ArticleTabularReviewCTAProps {
  postSlug: string;
}

export function ArticleTabularReviewCTA({ postSlug }: ArticleTabularReviewCTAProps) {
  const analytics = useAnalytics();

  const handleClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'tabular-review',
      ctaLabel: 'Mulai Ekstraksi',
    });
  };

  return (
    <div className="not-prose my-12 bg-white border-2 border-black overflow-hidden md:max-w-[450px] md:mx-auto">
      <div className="p-6 md:p-8">
        <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 leading-tight uppercase font-sans tracking-tight">
          Ratusan Dokumen,
          <br />
          Satu Tabel.
        </h3>

        <p className="text-gray-700 font-medium mb-6">
          Tabel Ekstraksi mengubah tumpukan dokumen menjadi spreadsheet yang terstruktur. Ekstrak informasi penting dengan cepat dan akurat.
        </p>

        <Link
          href="/id/home"
          onClick={handleClick}
          className="inline-flex items-center justify-center gap-2 bg-emerald-600 text-white px-6 py-4 font-bold text-sm md:text-base border-2 border-black hover:bg-emerald-700 transition-all hover:-translate-y-0.5"
        >
          Mulai Ekstraksi
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
